/**
 * Sound toggle for [data-enable-sound-toggle] video containers.
 * Listens on the button only — not the container — to avoid double-toggle on bubble.
 */
function initVideoSoundToggle(root = document) {
  root.querySelectorAll('[data-enable-sound-toggle]:not([data-sound-toggle-ready])').forEach((container) => {
    const button = container.querySelector('.video-sound-toggle-link');
    const video = container.querySelector('video');
    if (!button || !video) return;

    container.dataset.soundToggleReady = 'true';

    video.muted = true;
    video.controls = false;

    const updateButtonState = () => {
      const isMuted = video.muted;
      button.textContent = isMuted ? 'Off' : 'On';
      button.setAttribute('aria-pressed', String(!isMuted));
      button.setAttribute('aria-label', isMuted ? 'Enable video sound' : 'Disable video sound');
      container.classList.toggle('sound-active', !isMuted);
      container.classList.toggle('is-playing', !isMuted);
    };

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();

      video.muted = !video.muted;

      if (video.muted) {
        video.setAttribute('muted', 'muted');
        video.removeAttribute('data-user-sound');
      } else {
        video.setAttribute('data-user-sound', 'on');
        video.removeAttribute('muted');
        video.volume = 1;
        video.play().catch(() => {});
      }

      updateButtonState();
    });

    updateButtonState();
  });
}

function bootVideoSoundToggle() {
  initVideoSoundToggle();
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', bootVideoSoundToggle);
} else {
  bootVideoSoundToggle();
}

document.addEventListener('shopify:section:load', (event) => initVideoSoundToggle(event.target));
